import * as React from "react";
import { graphql } from "gatsby";
import ShippingInfoBox from "../components/ShippingInfoBox";
import Frame from "../components/Frame";

const COUNTRIES_TABLE = "countries";
const SHIPPING_METHODS_TABLE = "shipping_methods";
const shipping_zone_rates_TABLE = "shipping_zone_rates";

const getData = (nodes, tableName) => {
  return nodes.filter((d) => d.table === tableName).map((d) => d.data);
};

const IndexPage = ({ data: raw }) => {
  // sort data by table, exclude unnecessary fields
  const nodes = raw.allAirtable.nodes;

  const countries = getData(nodes, COUNTRIES_TABLE)
    .map(
      ({
        country,
        shipping_method,
        shipping_zone,
        country_excluded_items,
      }) => ({
        country,
        shipping_method,
        shipping_zone,
        country_excluded_items,
      })
    )
    // convert shipping method from array to single string
    .map((c) => ({ ...c, shipping_method: c.shipping_method[0] }));

  const shippingMethods = getData(nodes, SHIPPING_METHODS_TABLE).map(
    ({
      name,
      display_name,
      shipping_method_record_id,
      shipping_excluded_items,
    }) => ({
      name,
      display_name,
      shipping_method_record_id,
      shipping_excluded_items,
    })
  );

  const shippingRates = getData(nodes, shipping_zone_rates_TABLE).map(
    ({
      shipping_zone_rates_sample_rates,
      shipping_zone_rates_zone_name,
      shipping_zone_rates_record_id,
    }) => ({
      shipping_zone_rates_sample_rates,
      shipping_zone_rates_zone_name,
      shipping_zone_rates_record_id,
    })
  );

  return (
    <>
      <Frame />
      <ShippingInfoBox
        countries={countries}
        shippingMethods={shippingMethods}
        shippingRates={shippingRates}
      />
    </>
  );
};

export default IndexPage;

export const query = graphql`
  query AirtableData {
    allAirtable(sort: { order: ASC, fields: data___country }) {
      nodes {
        table
        data {
          country
          shipping_method
          shipping_zone
          country_excluded_items
          display_name
          name
          shipping_excluded_items
          shipping_method_record_id
          country_record_id
          shipping_zone_rates_zone_name
          shipping_zone_rates_sample_rates
          shipping_zone_rates_record_id
        }
      }
    }
  }
`;
